<template>
  <div class="postTravelMore">
    <Header></Header>
    <Nav type="2"></Nav>
    <Toptitle title="旅游指南"></Toptitle>
    <div class="activitiesCommunity_nav topicMore_nav">
      <a :class="type==1?'selection':'' " @click="getInterest()">景点</a>
      <a :class="type==2?'selection':'' " @click="getFood()">美食</a>
      <a :class="type==3?'selection':'' " @click="getNative()">特产</a>
    </div>
    <div class="road_list_more" v-show="type==1">
      <div class="road_list_item_more" v-for="(item,index) of interestList" :key="index" @click="goArticleDetail(item.id)">
        <img :src="item.picture" alt="">
        <div class="road_list_item_more_right">
          <h3>{{item.title}}</h3>
          <p>{{item.subtitle}}</p>
        </div>
      </div>
    </div>
    <div class="road_list_more" v-show="type==2">
      <div class="road_list_item_more" v-for="(item,index) of foodList" :key="index" @click="goArticleDetail(item.id)">
        <img :src="item.picture" alt="">
        <div class="road_list_item_more_right">
          <h3>{{item.title}}</h3>
          <p>{{item.subtitle}}</p>
        </div>
      </div>
    </div>
    <div class="road_list_more" v-show="type==3">
      <div class="road_list_item_more" v-for="(item,index) of nativeList" :key="index" @click="goArticleDetail(item.id)">
        <img :src="item.picture" alt="">
        <div class="road_list_item_more_right">
          <h3>{{item.title}}</h3>
          <p>{{item.subtitle}}</p>
        </div>
      </div>
    </div>
    <el-pagination background small layout="prev, pager, next" @current-change="handleCurrentChange" :page-size='this.dataJson.pageSize'
      :total="totalRecord" class="newspage showInPc" prev-text='< 上一页' next-text='下一页 >'></el-pagination>

    <el-pagination background small layout="prev, pager, next" @current-change="handleCurrentChange" :page-size='this.dataJson.pageSize'
      :total="totalRecord" class="newspage showInPhone" prev-text='<' next-text='>'></el-pagination>
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from './common/Header.vue'
  import Nav from './common/Nav.vue'
  import Footer from './common/Footer.vue'
  import Toptitle from './common/Toptitle.vue'
  export default {
    data() {
      return {
        dataJson: {
          pageSize: 12,
          pageNo: 1,
          type: '',
          targetid: ''
        },
        totalRecord: 1,
        type: 1,
        interestList: [],
        foodList: [],
        nativeList: []
      }
    },
    components: {
      Header,
      Footer,
      Nav,
      Toptitle
    },
    methods: {
      handleCurrentChange() {

      },
      getInterest() {
        this.dataJson.type = 7
        this.type = 1
        this.axios.post('api/index/getArticleList.do', this.qs(this.dataJson)).then(res => {
          this.interestList = res.data.results
          this.totalRecord = res.data.totalRecord
        })
      },
      getFood() {
        this.dataJson.type = 8
        this.type = 2
        this.axios.post('api/index/getArticleList.do', this.qs(this.dataJson)).then(res => {
          this.foodList = res.data.results
          this.totalRecord = res.data.totalRecord
        })
      },
      getNative() {
        this.dataJson.type = 9
        this.type = 3
        this.axios.post('api/index/getArticleList.do', this.qs(this.dataJson)).then(res => {
          this.nativeList = res.data.results
          this.totalRecord = res.data.totalRecord
        })
      },
      goArticleDetail(id) {
        this.$router.push({
          name: 'articleDetail',
          query: {
            id: id
          }
        })
      },
    },
    mounted() {
      this.dataJson.targetid = this.$route.query.targetid
      this.type = this.$route.query.type
      this.getInterest()
    }
  }
</script>

<style>
</style>
